const getters = {
  isLoading: state => state.isLoading,
  loadingIcon: state => state.loadingIcon,
  printoutLink: state => state.printoutLink,
  isDebug: state => state.isDebug,
  isInManagement: state => state.isInManagement,
};

export default getters;
